/* eslint-disable sonarjs/no-hardcoded-ip */

import { AppConfig, EnvConfig } from '@bn/primitives';

export class AppConfiguration {
  public config!: AppConfig;

  constructor(envConfig: EnvConfig) {
    const rasterImages = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const vectorImages = ['svg'];
    this.config = {
      currencyCode: 'USD',
      currencySymbol: '$',
      currencyDigits: '0.2-3',
      dataDebounceTime: 400,
      itemsPerPage: 60,
      filterDebounceTime: 500,
      extAuthCookieName: 'bnExtAuthData',
      pageItemsPerPage: {
        defaultGrid: 24,
        streamGrid: 24,
        streamCollection: 24,
        cdnLoggingView: 50,
        dnsLoggingView: 50,
        fileManager: 96,
        mcImages: 99,
        scopedApiKeys: 15,
        teamMembers: 15,
      },
      minimumPaymentAmount: 10,
      defaultPaymentAmount: 25,
      maximumPaymentAmount: 50000,
      minimumCryptoPaymentAmount: 15,
      defaultCryptoPaymentAmount: 25,
      maximumCryptoPaymentAmount: 2000,
      minimumBonusClaim: 1,
      referralBonus: 20,
      initialLoaderDelayMs: 200,
      skeletonTableRows: 5,
      search: {
        debounceTime: 500,
        maxItemsPerProduct: 5,
        minSearchTermLength: 3,
      },
      paginationItemsPerPage: 500,
      api: {
        rateLimitTime: 450,
        refreshInterval: {
          jwt: [5, 'm'],
          incompleteKyc: [1, 'm'],
          streamVideoProgressSync: [5, 's'],
          mcOverview: [15, 's'],
          esOverview: [10, 's'],
          mcStats: [30, 's'],
          news: [15, 'minute'],
          notifications: [5, 'minute'],
          statistics: [1, 'day'],
          support: [10, 'minute'],
          version: [1, 'minute'],
        },
      },
      stream: {
        pricing: {
          encoding: {
            SD: 0.025,
            HD: 0.05,
            '4K': 0.15,
          },
        },
      },
      dns: {
        default: {
          latencyZone: 'DE',
        },
        nameservers: {
          primary: {
            name: 'kiki.bunny.net',
            ipv4: '91.200.176.1',
            ipv6: '2400:52e0:fff0::1',
          },
          secondary: {
            name: 'coco.bunny.net',
            ipv4: '109.104.147.1',
            ipv6: '2400:52e0:fff2::1',
          },
        },
        soaEmail: 'hostmaster@bunny.net',
        logs: {
          daysHistory: 2,
        },
      },
      cdn: {
        logs: {
          daysHistory: 2,
        },
      },
      edgeScript: {
        daysHistory: {
          stats: 31,
        },
      },
      userFeeds: {
        showLastLength: {
          notificationsDropdown: 5,
        },
        // CORS-enabled changelog markdown source powering the "What's New" half of the notifications feed.
        changelogUrl: 'https://bunny.net/docs/changelog.md',
      },
      pricingTier: {
        defaultTier: {
          storageZone: 'DE',
          videoLibrary: 'DE',
        },
      },
      security: {
        tokenExpiration: {
          cdnTokenAuth: [1, 'day'],
          mediaEmbedView: [1, 'day'],
        },
      },
      storage: {
        ftpHostname: new URL(envConfig.edgeStorageApiUrl).host,
        s3AllowedRegionCodes: envConfig.s3AllowedRegionCodes,
      },
      mc: {
        requiredRegionIds: ['DE'],
      },
      uploadManager: {
        concurrentUploads: 2,
        userStatusUpdateMs: 1000,
        tus: {
          chunkSize: Infinity, // 256 * 1024 * 1024,
          retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
        },
      },
      toastr: {
        // Errors ignore this and stay up longer — see BnToastrService
        delay: 3 * 1000,
      },
      supportedUploadFileTypes: {
        audio: ['wav', 'aif', 'mp3', 'mid'],
        docs: ['pdf', 'doc', 'docx', 'docm', 'txt', 'xml', 'json', 'csv'],
        rasterImages,
        vectorImages,
        images: [...rasterImages, ...vectorImages],
        video: ['4mv', 'amv', 'avi', 'flv', 'm4p', 'm4v', 'mkv', 'mov', 'mp3', 'mp4', 'mpeg', 'mpg', 'mxf', 'ogg', 'ts', 'vod', 'wav', 'webm', 'wmv'],
        captions: ['srt', 'vtt'],
      },
    };
  }

  public getConfig(): AppConfig {
    return this.config;
  }
}
